<template>
  <div class="ecpl-footer">
    <div class="ecpl-footer__container">
      <div class="ecpl-footer__links-container">
        <div class="ecpl-footer__link-wrap">
          <router-link
            class="ecpl-footer__link"
            to="/teams"
          >
            Teams
          </router-link>
        </div>
        <div class="ecpl-footer__cta-link-wrap">
          <a
            href="https://player.ukpl.co.uk/"
            target="_blank"
            class="ecpl-footer__cta-link"
          >Login / Register</a>
        </div>
      </div>
      <div class="ecpl-footer__logos-container">
        <img
          src="@/assets/ECPL_Footer.png"
          alt="ECPL Logo"
          class="ecpl-footer__ecpl-text-logo"
        >
        <div class="ecpl-footer__divider" />
        <img
          src="@/assets/UKPL.png"
          alt="UKPL Logo"
          class="ecpl-footer__ukpl-logo"
        >
      </div>
      <p class="ecpl-footer__small-text">
        Original Website design and development by
        <a
          class="ecpl-footer__small-link"
          href="https://simonb.co.uk"
          target="_blank"
        >simonb.co.uk</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcplFooter'
};
</script>

<style scoped>
.ecpl-footer {
  background-color: var(--ecpl-red);
  width: 100%;
  min-height: 220px;
  display: flex;
  justify-content: center;
  padding: 20px;
  margin-top: 40px;
}

.ecpl-footer__container {
  width: 100%;
  max-width: 80rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  gap: 20px;
}

.ecpl-footer__links-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 479px) {
  .ecpl-footer__links-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 0 0 20px 0;
  }
}

.ecpl-footer__link {
  color: #fff;
  font-size: 1.1rem;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
}

.ecpl-footer__link:hover {
  color: var(--ecpl-blue);
}

.ecpl-footer__cta-link {
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  background-color: var(--ecpl-blue);
  padding: 8px 14px;
  border-radius: 20px;
  color: #fff;
}

.ecpl-footer__logos-container {
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.ecpl-footer__ecpl-text-logo {
  height: 50px;
  width: auto;
}

.ecpl-footer__ukpl-logo {
  height: 40px;
  width: auto;
}

.ecpl-footer__divider {
  height: 40px;
  width: 1px;
  background-color: #fff;
  opacity: 0.5;
}

.ecpl-footer__small-text {
  color: #fff;
  font-size: 16px;
}

.ecpl-footer__small-link {
  color: #fff;
  font-size: 16px;
}
</style>
